module.exports = __webpack_public_path__ + "static/media/02_crisalide.6f286fb5.jpg";